import { render, staticRenderFns } from "./trivia.vue?vue&type=template&id=8d0f508a"
import script from "./trivia.vue?vue&type=script&lang=js"
export * from "./trivia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports